import Caseificio from "../";

const routes = [{ name: "CaseificioSync", path: "/caseificiosync", component: Caseificio.CaseificioSync }];

export default routes;
